import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { SearchEmployeeComponent } from '../search-employee/search-employee.component';
import { Md5 } from 'ts-md5/dist/md5';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  name: string;
  name_en: string;

  acctList = [];
  branchList = [];
  menu_item = [];
  authList = [];
  acctDetail = '';

  roleList = [{ 'value': 'admin', 'role_ar': 'مشرف عام', 'role_en': 'Admin' },
    { 'value': 'manager', 'role_ar': 'مسؤول إداري', 'role_en': 'Manager' },
    { 'value': 'account', 'role_ar': 'محاسب', 'role_en': 'Accountant' },
    { 'value': 'casher', 'role_ar': 'كاشير', 'role_en': 'Casher' }];

  // addDialogRef: MatDialogRef<SearchEmployeeComponent>;

  model = {
    'table_name': 'user', 'user_id': '0', 'user_full_name': '', 'user_name': '', 'user_password': '',
    'employee_no': '', 'role': '', 'user_email': '',  
    'is_counter': '1', 'flag': 'new', 'key': 'user_id', 'acct_number': '', 'comment': ''
  };

  data_model = { 'base_date': new Date(this.applicationConstants.business_cycle.start_date) };

  sub_acct_model = {
    'table_name': 'sub_acct', 'acct_type_no': this.applicationConstants.acct_type_config['cash'],
    'main_acct_no': this.applicationConstants.main_acct_config['cash'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': '', 'acct_level': '0', 'is_leaf': '1',
    'is_cc': '1', 'emp_no': '', 'key': 'sub_acct_id', 'flag': 'new', 'deletable': '1'
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'acct_number': '0',
    'main_acct_no': this.applicationConstants.main_acct_config['cash'],
    'acct_type_no': this.applicationConstants.acct_type_config['cash'], 'base_date': '',
    'key': 'baseline_id', 'flag': 'new', 'baseline_amount': '0'
  };

  auth_model = {
    'table_name': 'user_auth', 'user_auth_id': '0', 'user_id': '0', 'menu_id': '0', 'menu_item_id': '0',
    'view_auth': '0', 'add_auth': '0', 'edit_auth': '0', 'delete_auth': '0'
  };

  search_obj = {
    'placeholder': 'اسم الموظف/ رقم الموظف/ رقم الجوال', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`employee`', 'selected_no': 'employee_no',
      'field_list': ['employee_no', 'name', 'name_en', 'mobile'],
      'condition': " AND `employee`.`employee_no` NOT IN (SELECT `user`.`employee_no` FROM `user`)"
    }]
  };

  displayedColumns = ['display_name_ar', 'view', 'add', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.menu_item);
  @ViewChild(MatSort) sort: MatSort;

  Success_Msg; Error_Msg; Employee_Placeholder; Username_Msg;
  Employee_Msg; Pass_Msg; Pass_Rep_Msg; Username_Exist_Msg;
  Belong_To_Msg; Acct_No_Msg; Acct_No_Exist;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<UserComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Employee_Placeholder').subscribe((res: string) => {
      this.Employee_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Employee_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Username_Msg').subscribe((res: string) => {
      this.Username_Msg = res;
    });

    translate.get('Employee_Msg').subscribe((res: string) => {
      this.Employee_Msg = res;
    });

    translate.get('Pass_Msg').subscribe((res: string) => {
      this.Pass_Msg = res;
    });

    translate.get('Pass_Rep_Msg').subscribe((res: string) => {
      this.Pass_Rep_Msg = res;
    });

    translate.get('Username_Exist_Msg').subscribe((res: string) => {
      this.Username_Exist_Msg = res;
    });

    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });
  }

  ngOnInit() {
    let query2, obj2;

    // get not leaf cash accts
    let parent_acct = this.applicationConstants.main_acct_config['cash'];
    obj2 = { cmd: 'getAccountList', parent_acct: parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];

        if (this.dialog_data == null) {
          if (this.acctList.length > 0) {
            parent_acct = this.acctList[0]['acct_number'];
            this.acctDetail = parent_acct + ' - ' + this.acctList[0]['sub_acct_name'] + ' - ' +
              this.acctList[0]['sub_acct_name_en'];
          }
          else
            this.acctDetail = parent_acct + ' - الحسابات النقدية - Cash Accounts';

          this.onChangeAcctSearch("", parent_acct);
        }
      });

    if (this.dialog_data != null) {
      this.model = this.dialog_data[0];
      // this.data_model['acct_number'] = this.model['acct_number'];

      this.name = this.dialog_data[1]['name'];
      this.name_en = this.dialog_data[1]['name_en'];

      if (this.model['acct_number'] != '') {
        query2 = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
        obj2 = { cmd: 'getList', query: query2 };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            if (data.data['list'].length > 0) {
              let sub_acct = data.data['list'][0];
              this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
              this.sub_acct_model['sub_acct_name'] = sub_acct['sub_acct_name'];
              this.sub_acct_model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
              this.sub_acct_model['acct_number'] = sub_acct['acct_number'];
              this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
              this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
              this.sub_acct_model['flag'] = 'update';
              // this.sub_acct_model['is_leaf'] = sub_acct['is_leaf'];
              // this.sub_acct_model['is_cc'] = sub_acct['is_cc'];

              // get parent acct detail
              query2 = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
              obj2 = { cmd: 'getList', query: query2 };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let parent_acct = data.data['list'][0];
                  this.acctDetail = sub_acct['parent_acct'] + ' - ' + parent_acct['sub_acct_name'] + ' - ' +
                    parent_acct['sub_acct_name_en'];
                  console.log(parent_acct);
                  // console.log((document.getElementById('parent_acct') as HTMLInputElement));
                  // (document.getElementById('search_value_1') as HTMLInputElement).value = sub_acct['parent_acct'] + ' - ' + 
                  //   parent_acct['sub_acct_name'] + ' - ' + parent_acct['sub_acct_name_en'];
                });
            }
          });
      }

      this.authList = [];
      query2 = "SELECT `menu_item`.`menu_item_id`, `menu_item`.`menu_id`, `menu_item`.`display_name_ar`, " +
        "`menu_item`.`display_name_en`, '0' AS `user_auth_id` FROM `menu_item`, `menu` WHERE " +
        "`menu_item`.`menu_id` = `menu`.`menu_id` AND `menu_item`.`display` = 'T' ORDER BY `menu`.`seq`, `menu_item`.`seq`";
      obj2 = { cmd: 'getList', query: query2 };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.menu_item = data.data['list'];
          this.dataSource = new MatTableDataSource(this.menu_item);
          this.dataSource.sort = this.sort;

          query2 = "SELECT `user_auth`.* FROM `user_auth`, `menu_item`, `menu` WHERE `user_auth`.`user_id` = '" +
            this.model.user_id + "' AND `user_auth`.`status` ='1' AND `user_auth`.`menu_item_id` = `menu_item`.`menu_item_id`" +
            " AND `menu_item`.`menu_id` = `menu`.`menu_id` ORDER BY `menu`.`seq`, `menu_item`.`seq`";
          obj2 = { cmd: 'getList', query: query2 };
    
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              this.authList = data.data['list'];
    
              let auth_existed = false;
              let view_flag = true;
              let add_flag = true;
              let edit_flag = true;
              let del_flag = true;
    
              this.menu_item.forEach(item => {
                auth_existed = false;
    
                this.authList.forEach(auth => {
                  if (item.menu_item_id == auth.menu_item_id) {
                    auth_existed = true;
    
                    item.user_auth_id = auth.user_auth_id;
                    (document.getElementById('view_' + item.menu_item_id) as HTMLInputElement).checked = (auth.view_auth == '1');
                    (document.getElementById('add_' + item.menu_item_id) as HTMLInputElement).checked = (auth.add_auth == '1');
                    (document.getElementById('edit_' + item.menu_item_id) as HTMLInputElement).checked = (auth.edit_auth == '1');
                    (document.getElementById('del_' + item.menu_item_id) as HTMLInputElement).checked = (auth.delete_auth == '1');
    
                    if (view_flag && auth.view_auth != '1')
                      view_flag = false;
    
                    if (add_flag && auth.add_auth != '1')
                      add_flag = false;
    
                    if (edit_flag && auth.edit_auth != '1')
                      edit_flag = false;
    
                    if (del_flag && auth.delete_auth != '1')
                      del_flag = false;

                    return false;
                  }
                });
    
                if (!auth_existed) {
                  item.user_auth_id = '0';
    
                  if (view_flag)
                    view_flag = false;
    
                  if (add_flag)
                    add_flag = false;
    
                  if (edit_flag)
                    edit_flag = false;
    
                  if (del_flag)
                    del_flag = false;
                }
              });

              (document.getElementById('view') as HTMLInputElement).checked = view_flag;
              (document.getElementById('add') as HTMLInputElement).checked = add_flag;
              (document.getElementById('edit') as HTMLInputElement).checked = edit_flag;
              (document.getElementById('del') as HTMLInputElement).checked = del_flag;
              (document.getElementById('user_auth') as HTMLInputElement).checked = (view_flag && add_flag && edit_flag && del_flag);
            });
        });
      
    } 
    else {
      query2 = "SELECT `menu_item`.`menu_item_id`, `menu_item`.`menu_id`, `menu_item`.`display_name_ar`, " +
      "`menu_item`.`display_name_en`, '0' AS `user_auth_id` FROM `menu_item`, `menu` WHERE " +
      "`menu_item`.`menu_id` = `menu`.`menu_id` AND `menu_item`.`display` = 'T' ORDER BY `menu`.`seq`, `menu_item`.`seq`";
    obj2 = { cmd: 'getList', query: query2 };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.menu_item = data.data['list'];
        this.dataSource = new MatTableDataSource(this.menu_item);
        this.dataSource.sort = this.sort;
      });
    }

    (document.getElementById('is_counter') as HTMLInputElement).checked = (this.model['is_counter'] == '1');
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.model['employee_no'] = search_result['no'];
    if (this.model['employee_no'] != '') {
      let query = "SELECT `name`, `name_en` FROM `employee` WHERE `employee_no` = '" + this.model['employee_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.name = data.data['list'][0]['name'];
          this.name_en = data.data['list'][0]['name_en'];
        });
    }
  }

  onChangeAcctSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.sub_acct_model['parent_acct'] = "";
      this.sub_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.sub_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '')
        this.sub_acct_model['parent_acct'] = parent_acct;

      // if (this.sub_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.acctList.length; index++) {
        element = this.acctList[index];
        if (element.acct_number == this.sub_acct_model['parent_acct']) {
          this.sub_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.sub_acct_model['acct_level'] == "0")
        this.sub_acct_model['acct_level'] = String(Number(this.sub_acct_model['acct_level']) + 1);

      if (this.model['user_id'] == '0' || (this.model['user_id'] != '0' && this.model['acct_number'] == '')) {
        this.sub_acct_model['acct_number'] = "";

        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
          this.sub_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0)
              this.sub_acct_model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
            else
              this.sub_acct_model['acct_number'] = String(result + 1);
          });
        // }
      }

    }
  }

  changeCounter() {
    this.model['is_counter'] = ((document.getElementById('is_counter') as HTMLInputElement).checked ? '1' : '0');
    // if (this.model['is_counter'] == '0')
    //   this.model['acct_number'] = '';
  }

  changeAcctNumber() {
    if (this.sub_acct_model['acct_number'] == "" && this.sub_acct_model['parent_acct'] != "")
      this.onChangeAcctSearch("", this.sub_acct_model['parent_acct']);
  }

  add() {
    if (this.model['employee_no'] == '') {
      alert(this.Employee_Msg);
      return;
      //(document.getElementById('searchEmployee') as HTMLInputElement).focus();
    }
    if (this.model['user_name'] == '') {
      alert(this.Username_Msg);
      (document.getElementById('user_name') as HTMLInputElement).focus();
      return;
    }
    if (this.model['user_id'] == '0' && this.model['user_password'] == '') {
      alert(this.Pass_Msg);
      (document.getElementById('user_password') as HTMLInputElement).focus();
      return;
    }
    if (this.model['user_id'] == '0' && (document.getElementById('repeat_password') as HTMLInputElement).value != this.model['user_password']) {
      alert(this.Pass_Rep_Msg);
      (document.getElementById('user_password') as HTMLInputElement).focus();
      return;
    }
    if (this.model['is_counter'] == '1' && this.sub_acct_model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }

    if (this.model['is_counter'] == '1' && this.sub_acct_model['acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }

    let values = [];
    let query, obj; // view_auth, add_auth, edit_auth, delete_auth;

    // if (this.model['is_counter'] != '1') this.model['is_counter'] = '0';
    //   this.model['is_counter'] = 1;
    // else


    if (this.model['user_id'] == '0') {
      // check if user name is exist
      query = "SELECT * FROM `user` WHERE `user_name` = '" + this.model['user_name'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          console.log(data.data['list'].length);

          if (data.data['list'].length > 0) {
            alert(this.Username_Exist_Msg);
            (document.getElementById('user_name') as HTMLInputElement).focus();
          }
          else {
            this.model['user_password'] = String(Md5.hashStr(this.model['user_password']));
            // if (this.model['is_counter'] == '1')
            //   this.model['acct_number'] = this.data_model['acct_number'];
            // if(this.model['is_counter'] == 1 ) this.model['acct_number'] = '101';
            values.push(this.model);

            if (this.model['is_counter'] == '1') {
              // let prefix = '101';
              // obj = { cmd: 'add', values: values, pk: 'acct_number', id: 'user_id', main_table: 'user', prefix: prefix };

              query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.sub_acct_model['acct_number'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let result = data.data['list'];
                  if (result.length > 0)
                    alert(this.Acct_No_Exist);
                  else {
                    this.model['acct_number'] = this.sub_acct_model['acct_number'];
                    // add casher as sub acct
                    this.sub_acct_model['sub_acct_name'] = ' صندوق ' + this.name;
                    this.sub_acct_model['sub_acct_name_en'] = 'Cashier ' + this.name_en;
                    this.sub_acct_model['emp_no'] = this.model['employee_no'];
                    this.sub_acct_model['acct_number'] = this.model['acct_number'];
                    values.push(this.sub_acct_model);

                    // add casher base
                    this.base_model['base_date'] = this.data_model['base_date'].getFullYear() + '-' +
                      (this.data_model['base_date'].getMonth() + 1) + '-' + this.data_model['base_date'].getDate() +
                      " 00:00:00";
                    // ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();
                    this.base_model['acct_number'] = this.model['acct_number'];
                    values.push(this.base_model);

                    obj = { cmd: 'add', values: values };

                    // console.log(obj);
                    // console.log(values);
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();

                        if (data.status['type'] == 'success') {
                          this.model['user_id'] = data.status['msg'][0]['id'];
                          this.saveMenuAuth([]);
                        }
                        else
                          alert(this.Error_Msg);
                      });
                  }
                });
            }
            else {
              obj = { cmd: 'add', values: values };

              console.log(obj);
              console.log(values);
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    this.model['user_id'] = data.status['msg'][0]['id'];
                    this.saveMenuAuth([]);
                  }
                  else
                    alert(this.Error_Msg);
                });
            }
          }
        });
    }
    else {
      values.push(this.model);

      if (this.model['is_counter'] == '1') {
        if (this.model['acct_number'] == '') {

          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.sub_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              let result = data.data['list'];
              if (result.length > 0)
                alert(this.Acct_No_Exist);
              else {
                this.model['acct_number'] = this.sub_acct_model['acct_number'];
                // add casher as sub acct
                this.sub_acct_model['sub_acct_name'] = ' صندوق ' + this.name;
                this.sub_acct_model['sub_acct_name_en'] = 'Casher ' + this.name_en;
                this.sub_acct_model['emp_no'] = this.model['employee_no'];
                this.sub_acct_model['acct_number'] = this.model['acct_number']; // '101' + this.utils.returnZeros(Number(this.model['user_id']));
                this.sub_acct_model['flag'] = 'new';
                // values[0]['acct_number'] = this.sub_acct_model['acct_number'];
                values.push(this.sub_acct_model);

                // add casher base
                this.base_model['base_date'] = this.data_model['base_date'].getFullYear() + '-' +
                  (this.data_model['base_date'].getMonth() + 1) + '-' + this.data_model['base_date'].getDate() + 
                  " 00:00:00";
                this.base_model['acct_number'] = this.model['acct_number']; // this.sub_acct_model['acct_number'];
                values.push(this.base_model);

                this.saveMenuAuth(values);
              }
            });
        }
        else {
          // add casher as sub acct
          this.sub_acct_model['sub_acct_name'] = ' صندوق ' + this.name;
          this.sub_acct_model['sub_acct_name_en'] = 'Casher ' + this.name_en;
          this.sub_acct_model['emp_no'] = this.model['employee_no'];
          this.sub_acct_model['acct_number'] = this.model['acct_number']; // '101' + this.utils.returnZeros(Number(this.model['user_id']));
          this.sub_acct_model['flag'] = 'update';

          values.push(this.sub_acct_model);
          this.saveMenuAuth(values);
        }
      }
      else 
        this.saveMenuAuth(values);
    }
  }

  saveMenuAuth(values) {
    let obj, view_auth, add_auth, edit_auth, delete_auth;

    this.menu_item.forEach(item => {

      view_auth = document.getElementById('view_' + item.menu_item_id) as HTMLInputElement;
      add_auth = document.getElementById('add_' + item.menu_item_id) as HTMLInputElement;
      edit_auth = document.getElementById('edit_' + item.menu_item_id) as HTMLInputElement;
      delete_auth = document.getElementById('del_' + item.menu_item_id) as HTMLInputElement;

      values.push({
        'table_name': 'user_auth', 'user_auth_id': item.user_auth_id, 'user_id': this.model['user_id'],
        'menu_id': item.menu_id, 'menu_item_id': item.menu_item_id,
        'flag': (item.user_auth_id == '0' ? 'new' : 'update'), 'key': 'user_auth_id',
        'view_auth': (view_auth.checked ? '1' : '0'), 'add_auth': (add_auth.checked ? '1' : '0'),
        'edit_auth': (edit_auth.checked ? '1' : '0'), 'delete_auth': (delete_auth.checked ? '1' : '0')
      });
    });

    obj = { cmd: 'updateAdv', values: values };

    console.log(obj);
    console.log(values);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else
          alert(this.Error_Msg);
      });
  }

  all_auth(value, menu_item_id = null) {
    let view = document.getElementById('view') as HTMLInputElement;
    let add = document.getElementById('add') as HTMLInputElement;
    let edit = document.getElementById('edit') as HTMLInputElement;
    let del = document.getElementById('del') as HTMLInputElement;
    let user_auth = document.getElementById('user_auth') as HTMLInputElement;

    if (value == 'all') {
      view.checked = (user_auth.checked);
      add.checked = (user_auth.checked);
      edit.checked = (user_auth.checked);
      del.checked = (user_auth.checked);

      this.all_auth('view');
      this.all_auth('add');
      this.all_auth('edit');
      this.all_auth('del');
    }

    else if (value == 'view') {
      if (!view.checked)
        user_auth.checked = view.checked;

      this.menu_item.forEach(element => {
        (document.getElementById('view_' + element['menu_item_id']) as HTMLInputElement).checked = (view.checked);
      });

    }
    else if (value == 'add') {
      if (!add.checked)
        user_auth.checked = add.checked;

      this.menu_item.forEach(element => {
        (document.getElementById('add_' + element['menu_item_id']) as HTMLInputElement).checked = (add.checked);
      });

    }

    else if (value == 'edit') {
      if (!edit.checked)
        user_auth.checked = edit.checked;

      this.menu_item.forEach(element => {
        (document.getElementById('edit_' + element['menu_item_id']) as HTMLInputElement).checked = (edit.checked);
      });

    }


    else if (value == 'del') {
      if (!del.checked)
        user_auth.checked = del.checked;

      this.menu_item.forEach(element => {
        (document.getElementById('del_' + element['menu_item_id']) as HTMLInputElement).checked = (del.checked);
      });

    }

    else if (value == 'view_item') {
      let flag = true;

      if (!(document.getElementById('view_' + menu_item_id) as HTMLInputElement).checked) {
        view.checked = false;
        user_auth.checked = false;
        flag = false;
      }
      else {
        this.menu_item.forEach(element => {
          let view_item = document.getElementById('view_' + element['menu_item_id']) as HTMLInputElement;
          if (!view_item.checked) {
            view.checked = false;
            user_auth.checked = false;
            flag = false;
          }
        });
      }

      if (flag)
        view.checked = true;
    }

    else if (value == 'add_item') {
      let flag = true;

      if (!(document.getElementById('add_' + menu_item_id) as HTMLInputElement).checked) {
        add.checked = false;
        user_auth.checked = false;
        flag = false;
      }
      else {
        this.menu_item.forEach(element => {
          let add_item = document.getElementById('add_' + element['menu_item_id']) as HTMLInputElement;
          if (!add_item.checked) {
            add.checked = false;
            user_auth.checked = false;
            flag = false;
          }
        });
      }

      if (flag)
        add.checked = true;
    }

    else if (value == 'edit_item') {
      let flag = true;

      if (!(document.getElementById('edit_' + menu_item_id) as HTMLInputElement).checked) {
        edit.checked = false;
        user_auth.checked = false;
        flag = false;
      }
      else {
        this.menu_item.forEach(element => {
          let edit_item = document.getElementById('edit_' + element['menu_item_id']) as HTMLInputElement;
          if (!edit_item.checked) {
            edit.checked = false;
            user_auth.checked = false;
            flag = false;
          }
        });
      }

      if (flag)
        edit.checked = true;
    }

    else if (value == 'del_item') {
      let flag = true;

      if (!(document.getElementById('del_' + menu_item_id) as HTMLInputElement).checked) {
        del.checked = false;
        user_auth.checked = false;
        flag = false;
      }
      else {
        this.menu_item.forEach(element => {
          let del_item = document.getElementById('del_' + element['menu_item_id']) as HTMLInputElement;
          if (!del_item.checked) {
            del.checked = false;
            user_auth.checked = false;
            flag = false;
          }
        });
      }

      if (flag)
        del.checked = true;
    }

    if (view.checked && add.checked && edit.checked && del.checked)
      user_auth.checked = true;
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
